<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="activeStep">
          <v-stepper-step step="1"> Información de evaluación de desempeño académico </v-stepper-step>
          <v-stepper-content step="1">
            <AcademicPerformanceEvaluationGeneralInfoForm
              :idPersonal="id"
              :evaluation="informacionGeneralAcademico"
              @save="(evaluations) => getLatestCreatedEvaluations(evaluations)"
            />
          </v-stepper-content>
          <v-stepper-step step="2"> Información de evaluación de desempeño académico </v-stepper-step>
          <v-stepper-content step="2">
            <v-container>
              <v-row>
                <v-col v-for="{ title, evaluation } in evaluations" :key="title">
                  <v-card color="secondary">
                    <v-card-title>
                      {{ title }}
                    </v-card-title>
                    <v-card-text>
                      <div class="text-caption">Estatus de evaluación</div>
                      <div class="text-body-1">
                        {{
                          evaluation.details && evaluation.details.statusLabel
                            ? evaluation.details.statusLabel
                            : 'No disponible'
                        }}
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="secondary" class="mx-2" @click="openEvaluationDialog(evaluation, title)"
                        >Evaluar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EvaluacionDesempenioInstitucionalDialogComponent from '../../components/desarrollo_policial/EvaluacionDesempenioInstitucionalDialogComponent.vue'
import AcademicPerformanceEvaluation from '../../modules/evaluacion-desempeño-academico/domain/entities/AcademicPerformanceEvaluation'
import { mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '../../plugins/dialog-types'
import AcademicPerformanceEvaluationGeneralInfoForm from '../../components/desarrollo_policial/evaluacion-desempeño-academico/forms/AcademicPerformanceEvaluationGeneralInfoForm.vue'
import RespetoValoresPrincipiosApiRepository from '@src/modules/respeto-valores-principios/infrastructure/RespetoValoresPrincipiosApi.repository'
import GetRespetoValoresPrincipios from '@src/modules/respeto-valores-principios/application/GetRespetoValoresPrincipios.usecase'
import RendimientoProfesionalismoApiRepository from '@src/modules/rendimiento-profesionalismo/infrastructure/RendimientoProfesionalismoApi.repository'
import GetRendimientoProfesionalismo from '@src/modules/rendimiento-profesionalismo/application/GetRendimientoProfesionalismo.usecase'
import DesempeñoInstitucionalApiRepository from '@modules/desempeño-institucional/infrastructure/DesempeñoInstitucionalApi.repository'
import GetDesempeñoInstitucional from '@modules/desempeño-institucional/application/GetDesempeñoInstitucional.usecase'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  components: {
    EvaluacionDesempenioInstitucionalDialogComponent,
    AcademicPerformanceEvaluationGeneralInfoForm,
  },

  data() {
    return {
      activeStep: 1,
      informacionGeneralAcademico: new AcademicPerformanceEvaluation(this.id),
      evaluations: [],
    }
  },

  methods: {
    ...mapActions('reactivoValor', ['fetchReactivoValor']),
    ...mapActions('reactivosEvaluacion', [
      'fetchReactivosDesempenioInstitucional',
      'fetchReactivosRendimientoProfesionalismo',
    ]),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('evaluacionesPersonal', ['SET_SELECTED_EVALUATION']),

    async getLatestCreatedEvaluations(evaluations) {
      try {
        const [respectForValuesAndPrinciples, performanceAndProfessionalism, institutionalPerformance] =
          await Promise.all([
            new GetRespetoValoresPrincipios(new RespetoValoresPrincipiosApiRepository()).execute({
              idPersonal: this.id,
              idEvaluacion: evaluations.respectForValuesAndPrinciplesEvaluationId,
            }),
            new GetRendimientoProfesionalismo(new RendimientoProfesionalismoApiRepository()).execute({
              idPersonal: this.id,
              idEvaluacion: evaluations.performanceAndProfessionalismEvaluationId,
            }),
            new GetDesempeñoInstitucional(new DesempeñoInstitucionalApiRepository()).execute({
              idPersonal: this.id,
              idEvaluacion: evaluations.institutionalPerformanceEvaluationId,
            }),
          ])

        if (respectForValuesAndPrinciples) {
          this.evaluations.push({
            title: 'Respeto a los principios y valores',
            evaluation: respectForValuesAndPrinciples,
          })
        }

        if (performanceAndProfessionalism) {
          this.evaluations.push({
            title: 'Rendimiento y profesionalismo',
            evaluation: performanceAndProfessionalism,
          })
        }

        if (institutionalPerformance) {
          this.evaluations.push({
            title: 'Desempeño institucional',
            evaluation: institutionalPerformance,
          })
        }

        this.activeStep = 2
      } catch {
        throw new Error('Error al obtener las evaluaciones de desempeño académico')
      }
    },

    async openEvaluationDialog(evaluation, title) {
      switch (title) {
        case 'Desempeño institucional':
          await this.fetchReactivosDesempenioInstitucional()
          break
        case 'Rendimiento y profesionalismo':
          await this.fetchReactivosRendimientoProfesionalismo()
          break
        case 'Respeto a los principios y valores':
          await this.fetchReactivoValor()
          break
      }

      this.SET_SELECTED_EVALUATION(evaluation)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_EVALUACION_DESEMPEÑO_ACADEMICO)
    },
  },
}
</script>
